var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('app-header'),_c('div',[_c('router-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }